<template>
<form v-on:submit.prevent="login">
  <div>
    <div class="primary-panel--heading">
      <h3 class="h3">Login</h3>
    </div>

    <!-- fulname -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('email') }"
      >
        <input
          class="primary-input--field"
          id="id1"
          name="email"
          type="text"
          value
          v-model="email"
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|email'" 
        >
        <label class="primary-input--label" for="id1" onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);">Enter email</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              transform="translate(-731 -21)"
              d="M739.99 21a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.2-10.2c.44 0 .8.34.8.75v4.5c0 .41-.36.75-.8.75h-6.4c-.44 0-.8-.34-.8-.75v-4.5c0-.41.36-.75.8-.75zm0 1.5v-.75l-3.2 1.88-3.2-1.88v.75l3.2 1.88z"
            ></path>
          </svg>
        </div>
        <div v-show="errors.has('email')" class="primary-input--error">
          <div class="primary-input--error-text">Please enter valid email address</div>
          <div class="primary-input--error-icon"></div>
        </div>
      </div>
    </div>
    
    <!--./fulname -->
    <!-- password -->
    <div class="inputs-grid--full">
      <div class="login--password-input">
        <div
          data-input-module="primary-input"
          class="form-group primary-input primary-input---with-icon"
          v-bind:class="{ 'primary-input---with-error' : errors.has('password') }"
        >
          <input
            class="primary-input--field"
            id="password"
            name="password"
            type="password"
            data-validation-can-be-disabled
            data-validation-disabled
            required
            value
            v-model="password"
            data-inline-validation-bind="true"
            onkeyup="this.setAttribute('value', this.value);"
            onchange="this.setAttribute('value', this.value);"
            data-toggle="blur"
            v-validate="'required|min:6'" 
          >
          <label class="primary-input--label" for="password">Enter password</label>
          <div class="primary-input--label-line-break"></div>
          <div class="primary-input--decoration"></div>
          <div class="primary-input--suffix">
            <div class="primary-input--password-eye" onclick="window.showPassword(this)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="11"
                height="7"
                viewBox="0 0 11 7"
              >
                <path
                  transform="translate(-1190 -502)"
                  d="M1201 505.5a6.15 6.15 0 0 1-5.5 3.5 6.15 6.15 0 0 1-5.5-3.5 6.15 6.15 0 0 1 5.5-3.5c2.4 0 4.48 1.42 5.5 3.5zm-2.92-1.72a2.78 2.78 0 0 1-2.58 3.76 2.78 2.78 0 0 1-2.58-3.76 5.02 5.02 0 0 0-1.74 1.72c.41.66.96 1.22 1.6 1.64a4.97 4.97 0 0 0 5.43 0c.65-.42 1.2-.98 1.6-1.64a5.28 5.28 0 0 0-1.73-1.72zm-3.61-.45c-.57 0-1.03.47-1.03 1.05 0 .58.46 1.05 1.03 1.05.57 0 1.03-.47 1.03-1.05 0-.58-.46-1.05-1.03-1.05z"
                ></path>
              </svg>
            </div>
          </div>
          <div class="primary-input--icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                transform="translate(-130 -333)"
                d="M139 333a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm2.25-8.53c.41 0 .75.34.75.76v3.8c0 .43-.34.77-.75.77h-4.5a.76.76 0 0 1-.75-.76v-3.81c0-.42.34-.76.75-.76h.38v-.77c0-1.05.84-1.9 1.87-1.9a1.9 1.9 0 0 1 1.88 1.9v.77zm-3.41-.77v.77h2.32v-.77c0-.65-.52-1.18-1.16-1.18-.64 0-1.16.53-1.16 1.18z"
              ></path>
            </svg>
          </div>
          <div v-show="errors.has('password')" class="primary-input--error">
          <div class="primary-input--error-text">Enter password</div>
          <div class="primary-input--error-icon"></div>
        </div>
        </div>
        
      </div>
    </div>
    <!--./password -->
    <div class="login--forget-password">
      <a href="#" class="alternative-link" id="forgotpsw">Forgot password?</a>
    </div>

    <div>
        <vue-recaptcha ref="recaptcha"
                       sitekey="6Lc_o1omAAAAAGFRCWdOQlyPYO763S0TNsMyeLAo"
                       style="display: flex; justify-content: center; margin-top: 10px;"
                       @verify="onCaptchaVerified"
                       @expired="onCaptchaExpired"
                       size="normal"></vue-recaptcha>

        <!--<div style="color:red" v-if="!(this.captchaToken.length > 0)">Please tick recaptcha</div>-->
    </div>

    <div class="text-center mb-3">
      <button type="submit" class="btn btn-primary block">Log in</button>
    </div>

    <div class="account">
      <label class="text-center">
        Don't have account?
        <a href="#" id="signup">Sign up here</a>
      </label>
    </div>
  </div>
  </form>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";

var me;
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      captchaToken: ""
    };
  },
  mounted() {
    me = this;
  },
  components: {
    VueRecaptcha,
  },
  methods: {
    onCaptchaVerified: function (response) {
          if (response) {
              this.captchaToken = response;
          }
    },
      onCaptchaExpired() {
        this.captchaToken = "";
        this.$refs.recaptcha.reset();
    },

    signupWindow: function () {
      this.$store.dispatch("signupWindow");
    },
    login: function() {
        if (!this.captchaToken) {
            return;
        }

      this.$validator.validate().then(result => {
        if (result) {
          this.$store.dispatch("login", {
            email: this.email,
            password: this.password
          });
          this.captchaToken = "";
          this.$refs.recaptcha.reset();
        }
      });
    }
  },
  computed: {
    ...mapState({
      hasError: state => state.user.loginHasError
    })
  }
};
</script>